export default __webpack_public_path__ + "static/l4-hero-phone-img-6d6c41796daa85ed019f0156d8ebd5e8.png";